import React, { useCallback, useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { useShortCut } from "Hook/useShortCut";
import { useOutsideHandler } from "Hook/useOutsideHandler";


import * as baseActions from 'modules/base';


const DetailViewer = ({body, callback, blockShortCut}) => {

  const dispatch = useDispatch();

  const refPopup = useRef();
  const refInner = useRef();
  const animationDuration = 420;


  const handleClickClose = useCallback((result) => {
    refPopup.current.classList.remove('active');
    
    if (document.querySelectorAll('.issuePop').length <= 1) {
      document.querySelector('.bottom-ad').classList.add('hide')
    }
    
    if (callback) {
      setTimeout(() => {
        callback(result);
      }, animationDuration);
    }
  },[callback]);


  useEffect(()=>{
    refPopup.current.classList.add('active');
    setTimeout(() => {
      document.querySelector('.bottom-ad').classList.remove('hide')
    }, animationDuration);
  },[])

  useEffect(()=>{
    dispatch(baseActions.addPopupCnt());
    return () => {
      dispatch(baseActions.subPopupCnt());
    }
  },[dispatch]);


  
  const handleShortCut = useCallback(key => {
    if (blockShortCut) {
      return;
    }

    switch(key) {
      case 'Escape':
        handleClickClose(false);
        break;
      default:
    }
  },[handleClickClose, blockShortCut]);

  useShortCut(handleShortCut);
  useOutsideHandler({ 
    refDom: refInner, 
    onClick: handleClickClose.bind(null, false), 
    disabled: blockShortCut,
  });


  return (
    <div className="issuePop" ref={refPopup}>
      <div className="inner" ref={refInner}>
        <div className="subject">
          {body}
        </div>
        <button type="button" className="close" onClick={handleClickClose.bind(this, false)}>닫기</button>
      </div>
    </div>
  )
}

export default DetailViewer;